import { v4 as uuidv4 } from "uuid";
import { generateStaticQuestionId } from "../../../../../utils/goalsUtils";

export const cultureOfInclusionDirector = {
    "blockId": uuidv4(),
    "description": "<p>Enables all members in the team to do their best work by creating an environment of trust, respect, and belongingness. Actively engages to.</p>",
    "goalId": "dynamic360Strength",
    isRequired: true,
    feedbackBasedCondition: [
        {
            answeringCondition: [
                {
                    columnValues: ["1", "2"],
                    numberOfAnswersNeeded: 3,
                },
                {
                    columnValues: ["3", "4"],
                    numberOfAnswersNeeded: 3,
                },
                {
                    columnValues: ["5", "6"],
                    numberOfAnswersNeeded: 3,
                }
            ]
        }

    ],
    allowNAOption: true,
    "questions": [
        {
            "question": "",
            "options": [
                {
                    "label": "Never",
                    "value": "1"
                },
                {
                    "label": "Rarely",
                    "value": "2"
                },
                {
                    "label": "Occasionally",
                    "value": "3"
                },
                {
                    "label": "Sometimes",
                    "value": "4"
                },
                {
                    "label": "Usually",
                    "value": "5"
                },
                {
                    "label": "Always",
                    "value": "6"
                },
                { "label": "Can't answer", "value": "0" }
            ],
            "questionDimension": "Custom Matrix",
            "type": "matrix",
            "qid": uuidv4(),
            "matrixQuestions": [
                {
                    "subCategoryId": generateStaticQuestionId("Build Trust & Camaraderie"),
                    "subCategory": "Build Trust & Camaraderie",
                    "staticQuestionId": generateStaticQuestionId("Treats all people with respect, regardless of their position or background"),
                    "HTMLText": "<p>Treats all people with respect, regardless of their position or background</p>",
                    "isSelected": true,
                    "text": "Treats all people with respect, regardless of their position or background",
                    "value": uuidv4()
                },
                {
                    "subCategoryId": generateStaticQuestionId("Build Trust & Camaraderie"),
                    "subCategory": "Build Trust & Camaraderie",
                    "staticQuestionId": generateStaticQuestionId("Considers diverse perspectives when making decisions"),
                    "HTMLText": "<p>Considers diverse perspectives when making decisions</p>",
                    "isSelected": true,
                    "text": "Considers diverse perspectives when making decisions",
                    "value": uuidv4()
                },
                {
                    "subCategoryId": generateStaticQuestionId("Build Trust & Camaraderie"),
                    "subCategory": "Build Trust & Camaraderie",
                    "staticQuestionId": generateStaticQuestionId("Fosters a climate of open and candid dialogues"),
                    "HTMLText": "<p>Fosters a climate of open and candid dialogues</p>",
                    "isSelected": true,
                    "text": "Fosters a climate of open and candid dialogues",
                    "value": uuidv4()
                },
                {
                    "subCategoryId": generateStaticQuestionId("Encourage Inclusiveness & Diversity"),
                    "subCategory": "Encourage Inclusiveness & Diversity",
                    "staticQuestionId": generateStaticQuestionId("Challenges own and others' biases and beliefs when making decisions"),
                    "HTMLText": "<p>Challenges own and others' biases and beliefs when making decisions</p>",
                    "isSelected": true,
                    "text": "Challenges own and others' biases and beliefs when making decisions",
                    "value": uuidv4()
                },
                {
                    "subCategoryId": generateStaticQuestionId("Encourage Inclusiveness & Diversity"),
                    "subCategory": "Encourage Inclusiveness & Diversity",
                    "staticQuestionId": generateStaticQuestionId("Leverages various networks to drive high performance"),
                    "HTMLText": "<p>Leverages various networks to drive high performance</p>",
                    "isSelected": true,
                    "text": "Leverages various networks to drive high performance",
                    "value": uuidv4()
                },
                {
                    "subCategoryId": generateStaticQuestionId("Encourage Inclusiveness & Diversity"),
                    "subCategory": "Encourage Inclusiveness & Diversity",
                    "staticQuestionId": generateStaticQuestionId("Creates an inclusive environment for people of different perspectives, cultures, and generations"),
                    "HTMLText": "<p>Creates an inclusive environment for people of different perspectives, cultures, and generations</p>",
                    "isSelected": true,
                    "text": "Creates an inclusive environment for people of different perspectives, cultures, and generations",
                    "value": uuidv4()
                },
                {
                    "subCategoryId": generateStaticQuestionId("Adapts to Cultural Contexts"),
                    "subCategory": "Adapts to Cultural Contexts",
                    "staticQuestionId": generateStaticQuestionId("Seeks opportunities to learn about different cultures, value systems, and beliefs"),
                    "HTMLText": "<p>Seeks opportunities to learn about different cultures, value systems, and beliefs</p>",
                    "isSelected": true,
                    "text": "Seeks opportunities to learn about different cultures, value systems, and beliefs",
                    "value": uuidv4()
                },
                {
                    "subCategoryId": generateStaticQuestionId("Adapts to Cultural Contexts"),
                    "subCategory": "Adapts to Cultural Contexts",
                    "staticQuestionId": generateStaticQuestionId("Adapts behaviors based on cultural context and knowledge"),
                    "HTMLText": "<p>Adapts behaviors based on cultural context and knowledge</p>",
                    "isSelected": true,
                    "text": "Adapts behaviors based on cultural context and knowledge",
                    "value": uuidv4()
                },
                {
                    "subCategoryId": generateStaticQuestionId("Adapts to Cultural Contexts"),
                    "subCategory": "Adapts to Cultural Contexts",
                    "staticQuestionId": generateStaticQuestionId("Leads by example and is a role model for Applied Materials values"),
                    "HTMLText": "<p>Leads by example and is a role model for Applied Materials values</p>",
                    "isSelected": true,
                    "text": "Leads by example and is a role model for Applied Materials values",
                    "value": uuidv4()
                },
            ],
            "questionLabel": "Custom Matrix"
        }
    ],
    "isSelected": true,
    "type": "matrix",
    "dimension": "Inclusion"
}